<template>
  <v-container fluid>
    <div>
      <h3 class="headline">{{ $t('Order Summary') }}</h3>
      <div v-if="isPowerbuyPage" class="py-3">
        <v-layout wrap>
          <v-flex>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'all'"
                :outline="filterApp != 'all'"
                :color="filterApp != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'facebook'"
                :outline="filterApp != 'facebook'"
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
                >{{ $t('facebook') }}
              </v-btn>
              <v-btn
                small
                depressed
                class="ma-1"
                @click="filterApp = 'line'"
                :outline="filterApp != 'line'"
                :color="filterApp != 'line' ? 'grey' : 'primary'"
                >{{ $t('line') }}
              </v-btn>
              <template>
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="filterApp = 'instagram'"
                  :outline="filterApp != 'instagram'"
                  :color="filterApp != 'instagram' ? 'grey' : 'primary'"
                  >{{ $t('instagram') }}
                </v-btn>
              </template>
            </div>
          </v-flex>
          <v-flex style="display: flex; justify-content: flex-end">
            <multiselect
              placeholder="เลือกสาขา"
              label="branch"
              @input="handleChangeShop"
              :options="powerbuyShopOptions"
              :show-labels="false"
              v-model="filterShop"
              style="max-width: 300px"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-2">
        <date-filter
          v-model="selectedDate"
          @changeDate="onSelectedDate"
          :default-filter="'today'"
          :showTime="true"
        ></date-filter>

        <v-layout
          wrap
          class="mt-2"
          v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
        >
          <v-flex xs12 sm6>
            <span class="order_summary_datepicker">{{ $t('from') }}:</span>
            <v-layout wrap row class="mb-2">
              <v-flex xs8 class="form-control">
                <datepicker
                  v-model="selectedDate.start"
                  @selected="onSelectedStartDate"
                ></datepicker>
              </v-flex>
              <v-flex xs4 class="form-control">
                <v-dialog
                  ref="starttime"
                  v-model="showStartTimeDialog"
                  :return-value.sync="starttime"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div class="pl-2 pr-2">
                      <input
                        type="text"
                        readonly
                        v-on="on"
                        placeholder="00:00"
                        v-model="starttime"
                      />
                    </div>
                  </template>
                  <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="showStartTimeDialog = false">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.starttime.save(starttime)
                        showStartTimeDialog = false
                        changeDate('custom_time')
                      "
                      >{{ $t('Confirm') }}</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <span class="order_summary_datepicker">{{ $t('to') }}:</span>
            <v-layout wrap row class="mb-2">
              <v-flex xs8 class="form-control">
                <datepicker
                  v-model="selectedDate.end"
                  style
                  @selected="onSelectedEndDate"
                ></datepicker>
              </v-flex>
              <v-flex xs4 class="form-control">
                <v-dialog
                  ref="endtime"
                  v-model="showEndTimeDialog"
                  :return-value.sync="endtime"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div class="pl-2 pr-2">
                      <input type="text" readonly v-on="on" placeholder="00:00" v-model="endtime" />
                    </div>
                  </template>
                  <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="showEndTimeDialog = false">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.endtime.save(endtime)
                        showEndTimeDialog = false
                        changeDate('custom_time')
                      "
                      >{{ $t('Confirm') }}</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn color="primary" @click="loadSummary" small>{{ $t('Search') }}</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="loading" class="text-xs-center" style="min-height: 400px">
        <v-layout justify-center align-center row style="height: 400px">
          <v-flex>
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
      <template v-else>
        <v-divider class="mt-3 mb-3"></v-divider>

        <v-layout wrap>
          <v-flex xs12>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              v-if="['foodguru'].includes(selectedBot.theme)"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('all')"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('Reviewing')"
                :outline="filterStatus != 'Reviewing'"
                :color="filterStatus != 'Reviewing' ? 'grey' : 'primary'"
                >Reviewing {{ badge['Reviewing'] > 0 ? '(' + badge['Reviewing'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('Payment สำเร็จ')"
                :outline="filterStatus != 'Payment สำเร็จ'"
                :color="filterStatus != 'Payment สำเร็จ' ? 'grey' : 'primary'"
                >Payment สำเร็จ
                {{ badge['Payment สำเร็จ'] > 0 ? '(' + badge['Payment สำเร็จ'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('เปิดบิลสำเร็จ')"
                :outline="filterStatus != 'เปิดบิลสำเร็จ'"
                :color="filterStatus != 'เปิดบิลสำเร็จ' ? 'grey' : 'primary'"
                >เปิดบิลสำเร็จ
                {{ badge['เปิดบิลสำเร็จ'] > 0 ? '(' + badge['เปิดบิลสำเร็จ'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('ส่งของสำเร็จ')"
                :outline="filterStatus != 'ส่งของสำเร็จ'"
                :color="filterStatus != 'ส่งของสำเร็จ' ? 'grey' : 'primary'"
              >
                ส่งของสำเร็จ
                {{ badge['ส่งของสำเร็จ'] > 0 ? '(' + badge['ส่งของสำเร็จ'] + ')' : '' }}
              </v-btn>
            </div>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              v-else-if="['dtac-gaming'].includes(selectedBot.type)"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('all')"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('paid')"
                :outline="filterStatus != 'paid'"
                :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                >จ่ายแล้ว {{ badge['paid'] > 0 ? '(' + badge['paid'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('refilled')"
                :outline="filterStatus != 'refilled'"
                :color="filterStatus != 'refilled' ? 'grey' : 'primary'"
                >เติมแล้ว {{ badge['refilled'] > 0 ? '(' + badge['refilled'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('modify')"
                :outline="filterStatus != 'modify'"
                :color="filterStatus != 'modify' ? 'grey' : 'primary'"
                >แก้ไข {{ badge['modify'] > 0 ? '(' + badge['modify'] + ')' : '' }}</v-btn
              >
            </div>
            <div
              v-else-if="isCentralLive"
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeCategory({ name: 'all' })"
                :outline="filterCategoryStatus != 'all'"
                :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }}</v-btn
              >
              <v-btn
                small
                v-for="category in categories"
                :key="category.id"
                depressed
                class="ma-1"
                @click="changeCategory(category)"
                :outline="filterCategoryStatus != category.name"
                :color="filterCategoryStatus != category.name ? 'grey' : 'primary'"
                >{{ category.name }}</v-btn
              >
            </div>

            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              v-else
            >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('all')"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <template v-if="!['toacrm'].includes(selectedBot.theme)">
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('ordered')"
                  :outline="filterStatus != 'ordered'"
                  :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
                  >{{ $t('ordered') }}
                  {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('paid')"
                  :outline="filterStatus != 'paid'"
                  :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                  >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
                >
              </template>
              <template v-else>
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('waiting')"
                  :outline="filterStatus != 'waiting'"
                  :color="filterStatus != 'waiting' ? 'grey' : 'primary'"
                  >{{ $t('waiting') }}
                  {{ badge.waiting > 0 ? '(' + badge.waiting + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('pending')"
                  :outline="filterStatus != 'pending'"
                  :color="filterStatus != 'pending' ? 'grey' : 'primary'"
                  >{{ $t('pending') }}
                  {{ badge.pending > 0 ? '(' + badge.pending + ')' : '' }}</v-btn
                >
              </template>
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('shipped')"
                :outline="filterStatus != 'shipped'"
                :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
                >{{ $t('shipped') }} {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                @click="changeStatus('canceled')"
                :outline="filterStatus != 'canceled'"
                :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
              >
                {{ $t('cancel') }}
                {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}
              </v-btn>
            </div>
          </v-flex>

          <v-flex xs12 sm12 class="text-xs-right">
            <div class="text-xs-right">
              <!-- v-if="selectedBot.pagetype !== 'enterprise' && selectedBot.shippop_status" -->
              <template v-if="selectedBot.theme == 'foodguru' && selectedBot.shippop_status">
                <v-layout style="display: inline-block">
                  <v-btn
                    color="#0b9dd1"
                    :loading="loadingShippop"
                    depressed
                    dark
                    @click="shipWithShippop"
                    style="display: inline-block; margin-right: -5px"
                  >
                    <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Shippop
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="grey"
                        dark
                        v-on="on"
                        class="ml-0"
                        style="display: inline-block; border-radius: 0"
                        outline
                        icon
                      >
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile :href="`/${currentLang}/template?tab=Shippop`">
                        <v-list-tile-title>{{ $t('ดูรายการที่เคยส่ง') }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </template>
              <PrintAllCoversMonobo
                v-if="
                  [
                    '148831989096546',
                    '1229692217050821',
                    '135565533158593',
                    '488563718210335',
                    '799590883441878'
                  ].includes(selectedBot.pageid)
                "
                :orders="filterOrders"
                :circle="false"
                @onPrinCover="onPrinCover(true, $event)"
                style="display: inline-block"
              ></PrintAllCoversMonobo>
              <PrintAllCoversCentral
                v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                :orders.sync="filterOrders"
                :circle="false"
                @onPrinCover="onPrinCover(true, $event)"
                style="display: inline-block"
              ></PrintAllCoversCentral>
              <PrintAllCoverToacrm
                v-if="['toacrm'].includes(selectedBot.theme)"
                :orders.sync="filterOrders"
                :circle="false"
                @onPrinCover="onPrinCover(false, $event)"
                style="display: inline-block"
              ></PrintAllCoverToacrm>
              <print-all-covers
                v-else
                :orders.sync="filterOrders"
                :circle="false"
                @onPrinCover="onPrinCover(false, $event)"
                style="display: inline-block"
              ></print-all-covers>
              <span>
                <v-dialog persistent v-model="isEditShop" width="800">
                  <template v-slot:activator="{ on }">
                    <v-btn color="grey" outline v-on="on">
                      <em class="fa fa-pencil-alt mr-1" />
                      {{ $t('Edit Shop') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <div style="float: right" class="text-xs-right">
                      <v-btn @click="isEditShop = false" icon>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <v-card-text>
                      <h3 class="title">{{ $t('Profile') }}</h3>
                      <shop-profile
                        :isEdit="true"
                        :showAddress="true"
                        @onSave="isEditShop = false"
                      ></shop-profile>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                      <h3 class="title">{{ $t('Shop address') }}</h3>
                      <shipping-address></shipping-address>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
              <v-layout v-if="['toacrm'].includes(selectedBot.theme)" style="display: inline-block">
                <v-btn outline color="grey" @click="exportOrderSummaryToacrm" class="mr-0">
                  <em class="fas fa-file-export mr-1" />
                  {{ $t('export') }}
                </v-btn>
              </v-layout>
              <v-layout v-else style="display: inline-block">
                <v-btn
                  outline
                  color="grey"
                  @click="exportOrderSummary"
                  class="mr-0"
                  style="border-right: 0; display: inline-block"
                >
                  <em class="fas fa-file-export mr-1" />
                  {{ $t('export') }}
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="grey"
                      dark
                      v-on="on"
                      style="display: inline-block; border-radius: 0; margin-left: -10px"
                      outline
                      icon
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="exportOrderSummary('merge')">
                      <v-list-tile-title>{{ $t('Export old format') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="exportOrderSummary('kerry')">
                      <v-list-tile-title>{{ $t('Export kerry format') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="
                        [
                          '148831989096546',
                          '1229692217050821',
                          '135565533158593',
                          '488563718210335',
                          '799590883441878'
                        ].includes(selectedBot.pageid)
                      "
                      @click="exportOrderSummary('sap')"
                    >
                      <v-list-tile-title>{{ $t('Export SAP format') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
              <v-btn
                fab
                outline
                color="primary"
                @click="onRefresh"
                v-tooltip.top="$t('Refresh')"
                small
              >
                <em class="fa fa-refresh" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <!-- Tracking for Happy Noz -->
        <div
          class="text-xs-right mb-2"
          v-if="['335283187311293', '265953191921619'].includes(selectedBot.pageid)"
        >
          <div
            @click="exportTrackingOrder"
            style="
              display: inline-block;
              background: color;
              color: #ff706b;
              border: 1px solid #ff706b;
              padding: 7px;
              cursor: pointer;
              font-size: 15px;
              margin-right: 4px;
            "
          >
            <em class="fas fa-clipboard-list" />
            &nbsp;Export Order No.
          </div>
          <span class="upload">
            <label
              for="importFile"
              style="
                display: inline-block;
                background: #ff706b;
                color: white;
                padding: 7px;
                cursor: pointer;
                font-size: 15px;
              "
            >
              <em class="fas fa-truck" />
              &nbsp;Import Tracking No.
            </label>
            <input
              type="file"
              id="importFile"
              @change="handleImportFile($event)"
              style="display: none"
            />
          </span>
        </div>

        <div>
          <v-layout wrap>
            <v-flex xs12 sm4 class="form-control px-1">
              <input type="text" :placeholder="$t('Search')" v-model="search" />
            </v-flex>

            <v-flex sm4 class="px-1">
              <multiselect
                v-if="shippingOptions.length"
                label="name"
                v-model="shippingFilter"
                :options="filteredShipping"
                :placeholder="$t('Shipping')"
                track-by="value"
                :multiple="true"
                @input="changeShippingOption"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>

            <v-flex sm4 class="px-1">
              <multiselect
                v-if="filterPayment.length"
                label="name"
                v-model="paymentFilter"
                :options="filterPayment"
                :placeholder="$t('Payments')"
                track-by="value"
                :multiple="true"
                @input="changePaymentOption"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>

            <v-flex xs12 class="text-xs-center text-sm-right">
              <v-pagination
                v-model="pageNumber"
                :length="pageCount"
                @input="onClickPageinate"
                class="mb-2"
              ></v-pagination>
            </v-flex>
          </v-layout>
          <div style>
            <template v-if="filterSummary.length > 0">
              <v-layout>
                <v-flex sm3>
                  <v-checkbox
                    id="cbAll"
                    :label="$t('Check all')"
                    style="display: inline-block; margin: 0"
                    v-model="checkboxAll"
                    @change="clickCbAll"
                    color="primary"
                  ></v-checkbox>
                </v-flex>
                <v-spacer />
                <v-flex right-align style="padding-right: 1em"></v-flex>
                <v-flex sm4 v-if="!['lookchingiant', 'toacrm'].includes(selectedBot.theme)">
                  <multiselect
                    label="label"
                    v-model="status"
                    :disabled="!cbAll.length"
                    :options="orderStatusOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :placeholder="$t('Modify all status')"
                    selectLabel
                    selectedLabel
                    deselect-label
                    @select="onSelectOrderStatus"
                    v-if="!['foodguru'].includes(selectedBot.theme)"
                  ></multiselect>

                  <!-- foodguru -->
                  <multiselect
                    label="label"
                    v-model="status"
                    :disabled="!cbAll.length"
                    :options="foodguruOrderStatusOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :placeholder="$t('Modify all status')"
                    selectLabel
                    selectedLabel
                    deselect-label
                    @select="onSelectOrderStatus"
                    v-else
                  ></multiselect>
                </v-flex>
              </v-layout>
              <template v-for="(order, index) in filterSummary">
                <template v-if="selectedBot.pageid == '114660513608160'">
                  <forex-summary-item
                    :key="'forex_order_' + index"
                    :cbAll.sync="cbAll"
                    @assignCb="assignCb"
                    v-model="filterSummary[index]"
                    @updateOrder="updateOrder(order.id, $event)"
                    @onChangeStatus="onChangeStatus(order.id)"
                    :shippingOptions="shippingOptions"
                    :showProductDetail="showProductDetail"
                    @onShowProductDetail="onShowProductDetail"
                  ></forex-summary-item>
                </template>
                <template
                  v-else-if="
                    [
                      '148831989096546',
                      '1229692217050821',
                      '135565533158593',
                      '488563718210335',
                      '799590883441878'
                    ].includes(selectedBot.pageid)
                  "
                >
                  <monobo-summary-item
                    :key="'monobo_order_' + order.id"
                    :cbAll.sync="cbAll"
                    @assignCb="assignCb"
                    v-model="filterSummary[index]"
                    @updateOrder="updateOrder(order.id, $event)"
                    @onChangeStatus="onChangeStatus(order.id)"
                    :shippingOptions="shippingOptions"
                    :showProductDetail="showProductDetail"
                    @onShowProductDetail="onShowProductDetail"
                  ></monobo-summary-item>
                </template>
                <template v-else-if="['toacrm'].includes(selectedBot.theme)">
                  <ToacrmSummaryItem
                    :key="'order_' + order.id + '_' + order.virual_timestamp"
                    :cbAll.sync="cbAll"
                    @assignCb="assignCb"
                    v-model="filterSummary[index]"
                    @updateOrder="updateOrder(order.id, $event)"
                    @onChangeStatus="onChangeStatus(order.id)"
                    :shippingOptions="shippingOptions"
                    :showProductDetail="showProductDetail"
                    @onShowProductDetail="onShowProductDetail"
                  ></ToacrmSummaryItem>
                </template>
                <template v-else>
                  <summary-item
                    :key="'order_' + order.id + '_' + order.virual_timestamp"
                    :cbAll.sync="cbAll"
                    @assignCb="assignCb"
                    v-model="filterSummary[index]"
                    @updateOrder="updateOrder(order.id, $event)"
                    @onChangeStatus="onChangeStatus(order.id)"
                    :shippingOptions="shippingOptions"
                    :showProductDetail="showProductDetail"
                    @onShowProductDetail="onShowProductDetail"
                  ></summary-item>
                </template>
              </template>
              <div class="text-xs-right" style="padding-top: 10px">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>
            </template>
            <template v-else>
              <div class="text-xs-center" style="margin: 35px 0">
                <img
                  src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                  alt
                  style="width: 230px"
                />
                <h3 class="headline">{{ $t('No data') }}</h3>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <shippop-shipping
      :key="shippoptimestamp"
      v-model="showFilterShippopPackage"
      :orders="filterShippopPackages"
      @isEditShop="isEditShop = true"
    ></shippop-shipping>
    <v-dialog v-model="IsImportTrackingSuccess" width="570px" height="270px">
      <v-card>
        <div
          class="text-center"
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <div style="font-size: 24px; margin: 30px">
            ระบบอัปเดตสถานะการสั่งซื้อ<br />
            และแจ้ง Tracking No. ไปยังลูกค้าสำเร็จแล้ว
          </div>
          <div style="margin-bottom: 20px">
            <img src="/static/img/assets/check_operation.png" width="68px" height="64px" />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'

import Editable from '@/components/elements/Editable'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import XLSX from 'xlsx'
import SummaryItem from './SummaryItem'
import ForexSummaryItem from './ForexSummaryItem'
import ToacrmSummaryItem from './ToacrmSummaryItem'
import MonoboSummaryItem from './MonoboSummaryItem'
import OrderSummaryMobile from './OrderSummaryMobile'
import ModalHelp from '@/components/elements/ModalHelp'
import Multiselect from 'vue-multiselect'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoverToacrm from './PrintAllCoverToacrm.vue'
import PrintAllCoversMonobo from './PrintAllCoversMonobo.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import SelectShippopCourier from './SelectShippopCourier'

import ShippopShipping from './ShippopShipping.vue'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'

import PrintChillBill from './PrintChillBill'
import DateFilter from '@/components/view/dashboard/DateFilter'

import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'
import { PAGE } from '@/constants/page.js'

export default {
  data: function () {
    return {
      loading: true,
      shippingFilter: [],
      shippingOptions: [],
      isEditShop: false,
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      showProductDetail: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'today',
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0,
        pending: 0,
        waiting: 0
      },
      categorybadgebadge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0,
        pending: 0,
        waiting: 0
      },
      categories: [],
      status: '',

      foodguruOrderStatusOptions: [
        {
          label: 'Reviewing',
          value: 'Reviewing'
        },
        {
          label: 'Payment สำเร็จ',
          value: 'Payment สำเร็จ'
        },
        {
          label: 'เปิดบิลสำเร็จ',
          value: 'เปิดบิลสำเร็จ'
        },
        {
          label: 'ส่งของสำเร็จ',
          value: 'ส่งของสำเร็จ'
        }
      ],
      filterCategoryStatus: 'all',
      loadingShippop: false,
      showFilterShippopPackage: false,
      filterShippopPackages: [],
      currentPaymentID: null,
      showPreview: false,
      paymentFilter: [],
      shippoptimestamp: moment().format('x'),
      IsImportTrackingSuccess: false,
      filterApp: 'all',
      filterShop: null
    }
  },
  components: {
    datepicker,
    Editable,
    SummaryItem,
    OrderSummaryMobile,
    ShopProfile,
    ModalHelp,
    Multiselect,
    PrintAllCovers,
    PrintAllCoversCentral,
    PrintAllCoversMonobo,
    ForexSummaryItem,
    MonoboSummaryItem,
    SelectShippopCourier,
    ShippopShipping,
    ShippingAddress,
    PrintChillBill,
    DateFilter,
    ToacrmSummaryItem,
    PrintAllCoverToacrm
  },
  computed: {
    orderStatusOptions() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)) {
        return ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: this.$t(`ACOMMERCE_${status}`),
          value: status
        }))
      } else {
        return STATUS_OPTIONS.map((status) => ({
          ...status,
          label: this.$t(status.label)
        }))
      }
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    // cbAll() {
    //   return this.summary.filter(v=> {
    //     return v.cb
    //   }).map( v => v.id )
    // },
    filteredShipping() {
      let vm = this
      var options = vm.shippingOptions.map((el) => {
        return {
          name: vm.$t(el.name),
          value: el.name,
          count: vm.summary.filter((v) => v.shippingtype == el.name).length
        }
      })

      options.push({
        name: vm.$t('Shippop'),
        value: 'shippop',
        count: vm.summary.filter((v) =>
          ['booking', 'waiting', 'confirm'].includes(v.shippop_status)
        ).length
      })

      return options
    },
    filterPayment() {
      let vm = this
      return [
        {
          name: this.$t('Bank Transfer'),
          value: 'transfer',
          count: this.summary.filter((v) => v.payment == 'transfer' || v.payment == 'banktransfer')
            .length
        },
        {
          name: this.$t('cod_charge'),
          value: 'cod',
          count: this.summary.filter((v) => v.payment == 'cod').length
        },
        {
          name: this.$t('Qr Code'),
          value: 'qrcode',
          count: this.summary.filter((v) => v.payment == 'qrcode').length
        },
        {
          name: this.$t('Mobile Banking'),
          value: 'fbpay',
          count: this.summary.filter((v) => v.payment == 'fbpay').length
        },
        {
          name: this.$t('PayPal'),
          value: 'credit',
          count: this.summary.filter((v) => v.payment == 'credit').length
        },
        {
          name: this.$t('Credit card'),
          value: 'gbcredit',
          count: this.summary.filter((v) => v.payment == 'gbcredit').length
        }
      ].filter((el) => {
        return el.count > 0
      })
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    }),
    pageCount: function () {
      let l = this.badge[this.filterStatus]
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary: function (isAllPage) {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
            (el.akita_order_ref &&
              el.akita_order_ref.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.shippop_tracking_code &&
              el.shippop_tracking_code.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.remark && el.remark.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some(
            (v) => (v.value == 'shippop' && el.shippop_status != null) || el.shippingtype == v.value
          )
        })
      }

      if (vm.paymentFilter.length) {
        filter = filter.filter((el) => {
          return vm.paymentFilter.some((v) => el.payment == v.value)
        })
      }

      if (vm.selectedBot.theme == 'foodguru') {
        vm.badge = {
          all: 0,
          Reviewing: 0,
          'Payment สำเร็จ': 0,
          เปิดบิลสำเร็จ: 0,
          ส่งของสำเร็จ: 0
        }
      } else if (['dtac-gaming'].includes(this.selectedBot.type)) {
        vm.badge = {
          all: 0,
          paid: 0,
          refilled: 0,
          modify: 0
        }
      } else {
        vm.badge = {
          all: 0,
          canceled: 0,
          ordered: 0,
          paid: 0,
          shipped: 0,
          pending: 0,
          waiting: 0
        }
      }

      vm.badge.all = filter.length

      orders = filter.filter((val) => {
        vm.badge[val.status] += 1
        if (vm.filterStatus == 'all') return true
        else return val.status == vm.filterStatus
      })

      orders = orders.filter((val) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return orders.slice(start, end)
    },
    filterSummaryAllPage: function () {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }

      vm.badge = {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0,
        pending: 0,
        waiting: 0
      }
      vm.badge.all = filter.length

      orders = filter.filter((val, index) => {
        vm.badge[val.status] += 1
        if (vm.filterStatus == 'all') return true
        else return val.status == vm.filterStatus
      })
      orders = orders.filter((val, index) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      return orders
    },
    filterOrders: function () {
      let vm = this
      let orders = this.summary
      let filter = this.summary

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter((el) => el.status == vm.filterStatus)
        }
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    isPowerbuyPage() {
      return this.selectedBot.theme === 'powerbuy'
    },
    powerbuyShopOptions() {
      return this.$store.state.powerbuyBranchList
    }
  },
  async mounted() {
    this.loading = true
    // console.time('order')
    let promiseOrderSummary = await this.getOrderSummary()
    let promiseShipping = this.getShipping()
    var orders = await promiseOrderSummary
    await promiseShipping
    this.convertOrder(orders)
    // console.timeEnd('order')
    this.loading = false
    await this.$store.dispatch('loadPageProfile')

    if (this.isCentralLive) {
      this.getCategories()
    }
  },
  filters: {
    formatdate: function (value) {
      return moment(value).format('YYYY/MM/DD h:mm:ss a')
    }
  },
  methods: {
    exportOrderSummaryToacrm() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      // await this.getOrderForExport()
      let filter = this.filterOrders
      let filename = ''
      var json = []

      $.each(filter, function (index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      orders = orders.filter((val, index) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })
      // csvContent +=
      //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
      //   '\r\n'
      orders = orders.sort(
        (a, b) =>
          moment(b.timestamp).format('YYYYMMDDHHmm') - moment(a.timestamp).format('YYYYMMDDHHmm')
      )
      $.each(orders, function (index, val) {
        var productdetail = []
        try {
          var products = JSON.parse(val.productdetail)
        } catch (error) {
          var products = val.productdetail
        }

        try {
          if (typeof products == 'object' && products.length > 0) {
            products.map(function (product) {
              productdetail.push({
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free',
                cart_remark: product.cart_remark
              })
            })
          } else {
            productdetail[0] = val.productdetail
          }
        } catch (error) {
          productdetail[0] = val.productdetail
        }

        var realname = val.nameaddress ? val.nameaddress.split(' , ') : ''
        var shippingType = ''
        try {
          var jsondata = JSON.parse(val.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          if (val.shippingtype.includes('other')) {
            var shipping = vm.shippingOptions.find((el) => {
              return el.name == val.shippingtype
            })
            shippingType = shipping ? shipping[4] : val.shippingtype
          } else {
            shippingType = val.shippingtype
          }
        }

        var couponcode = ''
        try {
          jsondata = JSON.parse(val.jsonvalue)
          couponcode = jsondata.promocode ? jsondata.promocode : ''
        } catch (error) {}

        try {
          var nameaddress = JSON.parse(val.nameaddress)
          var fullAddress = `${nameaddress.address} เขต${nameaddress.district} แขวง${nameaddress.subDistrict} จังหวัด${nameaddress.province} ${nameaddress.postCode} เบอร์โทรศัพท์${nameaddress.phoneNumber}`
        } catch (error) {
          var fullAddress = val.nameaddress
        }

        var row = {
          'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
          'Order Number': val.id,
          'Status Order': val.status,
          รหัสของรางวัล: products.sku,
          รายการของรางวัล: products.name,
          จำนวนคะแนนก่อนแลก: parseFloat(val.total),
          แลกคะแนน: products.points,
          คะแนนคงเหลือ:
            (val.total ? parseFloat(val.total) : 0) - (val.amount ? parseFloat(val.amount) : 0),
          Shipping: shippingType ? vm.$t(shippingType) : '',
          'Tracking No.': val.trackingno,
          Remark: val.remark != null ? val.remark : '',
          Channel: val.app,
          'Social Name': val.first_name + ' ' + val.last_name,
          ชื่อลูกค้า: nameaddress.name,
          Address: fullAddress
        }
        if (vm.selectedBot.theme == 'runkan') {
          Object.assign(row, {
            'Run status': val.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ'
          })
        }

        json.push(row)

        if (productdetail.length > 1) {
          productdetail.map((detail, dindex) => {
            if (dindex != 0) {
              json.push({
                SKU: detail.sku,
                Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                Price: numeral(detail.price).format('0,0.00'),
                'SKU Amount': detail.quantity
              })
            }
          })
        }
      })
      filename = 'zwizshop'

      var dataWS = null
      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    onShowProductDetail(payload) {
      this.showProductDetail = payload
    },
    async shipWithShippop() {
      var selected = this.summary.filter((el) => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.shippop_status == null
        )
      })
      if (selected.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else if (selected.length > 300) {
        await this.$swal({
          title: 'ไม่สามารถส่งกับทาง shippop เกิน 300 ออเดอร์ต่อหนึ่งการทำรายการ',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else {
        this.filterShippopPackages = selected
        this.shippoptimestamp = moment().format('x')
        await this.$nextTick()
        this.showFilterShippopPackage = true
      }
    },
    closePreview() {
      location.reload()
    },

    changeShippingOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    changePaymentOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    async onPrinCover(allcontents, payload) {
      var orders = []
      if (allcontents) {
        var orders = await this.getOrderForExport()
      } else orders = this.filterOrders
      payload.printPdf(orders)
    },
    changeCategory(category) {
      this.filterCategoryStatus = category.name
      this.pageNumber = 1
    },
    getCategories() {
      let data = {
        pageid: this.selectedBot.pageid
      }

      if (vm.isPowerbuyPage && vm.filterShop) {
        Object.assign(data, { shop_main_pageid: vm.filterShop.shop_main_pageid })
      }

      api.getCategories(data, (err, response) => {
        if (response.responsecode == 200) {
          this.categories = response.categorylist
        }
      })
    },
    async onRefresh() {
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },
    getShipping() {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid }
        api.getAllShipingCharge(data, (error, response) => {
          if (error) reject(error)

          let result = Object.keys(response.shippinglist).map(function (key) {
            return { name: key, ...response.shippinglist[key] }
          })

          vm.shippingOptions = result
          vm.$store.state.shippinglist = response.shippinglist
          resolve()
        })
      })
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter((v) => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (!this.cbAll.length) {
        this.cbAll = this.filterSummaryAllPage.map((v) => v.id)
        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    onSelectOrderStatus(status) {
      let vm = this

      var orders = this.summary
        .filter((el) => {
          // if (this.selectedBot.pagetype !== 'enterprise') {
          //   return this.cbAll.includes(el.id) && el.shippop_status == null
          // } else {
          return this.cbAll.includes(el.id)
          // }
        })
        .map((el) => {
          return el.id
        })

      if (orders.length == 0) {
        return false
      }
      let data = {
        status: status.value,
        orderid: orders,
        pageid: this.selectedBot.pageid
      }
      vm.$store.dispatch('loading')
      api.putmultistatusordersummary(data, async function (error, response) {
        if (error) return console.error(error)
        var promiseStatus = []
        vm.summary.forEach(async (el) => {
          if (vm.cbAll.includes(el.id)) {
            if (vm.selectedBot.pageid != '1227843817265057') {
              if (status.value != 'canceled' && el.status == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve, reject) => {
                    api.orderstockdelete({ orderid: el.id }, () => {
                      resolve()
                    })
                  })
                )
              } else if (el.status != 'canceled' && status.value == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve, reject) => {
                    api.orderstockadd({ orderid: el.id }, () => {
                      resolve()
                    })
                  })
                )
              }
            }

            el.status = status.value
          }
        })
        await Promise.all(promiseStatus)
        vm.$store.dispatch('loading')
      })
    },
    onClickPageinate: function (pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    onSelectedDate: async function (value) {
      this.pageNumber = 1
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },
    onSelectedStartDate: async function (value) {
      this.pageNumber = 1
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    onSelectedEndDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadSummary() {
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },
    changeStatus: function (value) {
      this.filterStatus = value
      this.pageNumber = 1
      this.clearSelectAll()
    },
    async getOrderForExport() {
      let vm = this
      var response = await this.getOrderSummary(true, true)
      var orders = []
      if (response.data) {
        orders = response.data
      }
      let filter = orders

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter((el) => el.status == vm.filterStatus)
        }
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    clearSelectAll() {
      this.cbAll = []
      this.checkboxAll = false
    },
    getOrderSummary: function (allcontents, noclearselect) {
      let vm = this
      allcontents = allcontents ? allcontents : false

      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
          dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD HH:mm'),
          status: 'all',
          allcontents: allcontents
        }

        if (vm.isPowerbuyPage && vm.filterShop) {
          Object.assign(data, {
            shop_main_pageid: vm.filterShop.shop_main_pageid,
            app: vm.filterApp
          })
        }

        // vm.$store.dispatch('loading')
        api.getOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            // vm.$store.dispatch('loading')
            reject()
            return
          }
          if (response.data) {
            if (!noclearselect) {
              vm.clearSelectAll()
            }
            resolve(response)
          }
          // vm.$store.dispatch('loading')
        })
      })
    },
    convertOrder(response) {
      this.summary = response.data.map((el) => {
        return {
          ...el,
          virual_timestamp: moment().format('x')
        }
      })

      if (this.filterStatus == 'all') {
        this.badge = {
          all: response.all,
          canceled: response.canceled,
          ordered: response.ordered,
          paid: response.paid,
          shipped: response.shipped,
          pending: response.pending,
          waiting: response.waiting
        }
      }
    },
    onChangeStatus: function (index) {
      let vm = this
      vm.updateOrder(index, 'save')
    },
    updateOrder: async function (id, payload, callback) {
      let vm = this
      vm.$store.dispatch('loading')
      let order = vm.summary.find(function (element) {
        return element.id === id
      })
      let data = JSON.parse(JSON.stringify(order))

      if (payload == 'send' && data.status == 'canceled') data.sendreason = true
      else if (payload == 'send' && data.status == 'shipped') data.sendtrackingstatus = true

      if (data) {
        if (this.selectedBot.theme == 'lookchingiant') {
          data.shippingtype = ''
        }
        if (['dtac-gaming'].includes(this.selectedBot.type)) {
          data.nameaddress = ''
          data.trackingno = ''
          data.shippingtype = ''
        }
        api.editOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }

          order.virual_timestamp = moment().format('x')
          if (callback) {
            callback()
          }

          vm.$store.dispatch('loading')
        })
      }
    },
    async exportOrderSummary(type) {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      // await this.getOrderForExport()
      let filter = this.filterOrders
      let filename = ''
      var json = []

      $.each(filter, function (index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      orders = orders.filter((val, index) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      if (vm.$aston.astonpages.includes(vm.selectedBot.pageid)) {
        $.each(orders, function (index, val) {
          let note = val.note
          if (typeof note !== 'undefined' && note != null && note !== '') {
            try {
              note = JSON.parse(note)
            } catch (error) {
              return
            }
            var name, phone, address, zipcode, sku, sku2, sa_link, amount, proname
            name = phone = address = zipcode = sku = sku2 = sa_link = amount = proname = ''
            if (typeof note.name !== 'undefined') name = note.name
            if (typeof note.phone !== 'undefined') phone = note.phone
            if (typeof note.address !== 'undefined') address = note.address
            if (typeof note.zipcode !== 'undefined') zipcode = note.zipcode
            if (typeof note.sku !== 'undefined') {
              sku = note.sku
              var temp = sku.split('+')
              if (temp.length == 2) {
                sku = temp[0]
                sku2 = temp[1]
              }
            }
            if (typeof note.amount !== 'undefined') amount = note.amount
            // if (typeof note.proname !== 'undefined') proname = note.proname
            proname = val.productdetail
            if (typeof note.sa_link !== 'undefined' && !note.sa_link.includes('hatbot')) {
              sa_link = note.sa_link
            } else {
              if (
                vm.selectedBot.pageid == '1231805606976542' ||
                vm.selectedBot.pageid == '391365474996527' ||
                vm.selectedBot.pageid == '2105726733070683'
              ) {
                if (typeof note.sa_link !== 'undefined')
                  sa_link = note.sa_link + '-dc-bee-' + proname
              } else {
                if (typeof note.sa_link !== 'undefined') sa_link = note.sa_link + proname
              }
            }
            json.push({
              ลำดับ: index + 1,
              'Order No.': val.id,
              'ชื่อ-สกุล*': name,
              เบอร์โทร: phone,
              ที่อยู่: address,
              รหัสไปรษณีย์: zipcode,
              ไอดีสินค้า: sku,
              ไอดีสินค้า2: sku2,
              ชื่อสินค้า: proname,
              'ลิงค์ทำ order': sa_link,
              ราคาสินค้า: numeral(amount).format('0,0.00').toString(),
              หมายเหตุ: val.remark
            })
          }
        })
        filename = 'order_summary_' + moment().format('YYYY_MM_DD')
      } else {
        if (type == 'merge') {
          orders = orders.sort(
            (a, b) =>
              moment(a.timestamp).format('YYYYMMDDHHmm') -
              moment(b.timestamp).format('YYYYMMDDHHmm')
          )

          $.each(orders, function (index, val) {
            var productdetail = ''
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }

            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function (product) {
                  productdetail +=
                    product.name +
                    ' x ' +
                    product.quantity +
                    ` SKU:${product.sku ? product.sku : '- '}` +
                    (product.option ? ' (' + product.option + ')' : '') +
                    ' : ' +
                    (product.price > 0 ? '฿' + product.price : 'Free') +
                    '\r\n'
                })
              } else {
                productdetail = val.productdetail
              }
            } catch (error) {
              productdetail = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : ''
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find((el) => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            try {
              jsondata = JSON.parse(val.jsonvalue)
              couponcode = jsondata.promocode ? jsondata.promocode : ''
            } catch (error) {}

            json.push({
              'Order No.': val.id,
              Products: productdetail,
              Remark: val.remark,
              'Social Name': val.first_name + ' ' + val.last_name,
              'Real Name': realname.length > 1 ? realname[0] : '',
              Address: val.nameaddress,
              Price: numeral(val.amount).format('0,0.00').toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Created Date': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              SKU: products[0].sku ? `${products[0].sku}` : '-',
              Quantity: val.allquantity ? `${val.allquantity}` : '-',
              'Cutomer Code': couponcode
            })
          })

          filename = 'zwizshop'
        } else if (type == 'kerry') {
          orders = orders.sort(
            (a, b) =>
              moment(a.timestamp).format('YYYYMMDDHHmm') -
              moment(b.timestamp).format('YYYYMMDDHHmm')
          )
          $.each(orders, function (index, val) {
            var postcode = ''
            var phone = ''
            var name = ''
            var address = val.nameaddress.split(' , ')
            var result_address = ''

            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              shippingType = val.shippingtype
            }
            var price =
              shippingType == 'cod_charge' ? numeral(val.amount).format('0,0').toString() : 0
            if (address.length > 0) {
              name = address[0]
              address.splice(0, 1)
              phone = address[address.length - 1]
              address.splice(address.length - 1, 1)
              result_address = address.join('')
              var postcode_regex = /[0-9]{5}/g
              if (result_address.match(postcode_regex)) {
                var postcode_match = result_address.match(postcode_regex)
                if (postcode_match.length > 0) {
                  postcode = postcode_match[0]
                  result_address = result_address.replace(postcode, '')
                }
              }
            }

            json.push({
              No: index + 1,
              'Recipient Name': name,
              'Mobile No.': phone,
              Email: '',
              'Address #1': result_address,
              'Address #2': '',
              'Zip Code': postcode,
              'COD Amt (Baht)': price,
              Remark: val.remark
            })
          })
          filename = 'zwizshop_kerry'
        } else if (type == 'sap') {
          vm.sapFormat(filter)
          return false
        } else {
          // csvContent +=
          //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
          //   '\r\n'
          orders = orders.sort(
            (a, b) =>
              moment(b.timestamp).format('YYYYMMDDHHmm') -
              moment(a.timestamp).format('YYYYMMDDHHmm')
          )
          $.each(orders, function (index, val) {
            var productdetail = []
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }

            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function (product) {
                  productdetail.push({
                    name: product.name ? product.name : '',
                    quantity: product.quantity,
                    sku: product.sku ? product.sku : '',
                    option: product.option ? ' (' + product.option + ')' : '',
                    price: product.price > 0 ? product.price : 'Free',
                    cart_remark: product.cart_remark
                  })
                })
              } else {
                productdetail[0] = val.productdetail
              }
            } catch (error) {
              productdetail[0] = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : ''
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype && val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find((el) => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            try {
              jsondata = JSON.parse(val.jsonvalue)
              couponcode = jsondata.promocode ? jsondata.promocode : ''
            } catch (error) {}

            try {
              var nameaddress = JSON.parse(val.nameaddress)
              var fullAddress = `${nameaddress.name} ${nameaddress.address} เขต${nameaddress.district} แขวง${nameaddress.subDistrict} จังหวัด${nameaddress.province} ${nameaddress.postCode} เบอร์โทรศัพท์${nameaddress.phoneNumber}`
            } catch (error) {
              var fullAddress = val.nameaddress
            }

            const userid = val.userid
            let userid_split = null
            try {
              userid_split = val.app == 'line' ? userid.split('__')[0] : userid
            } catch (error) {
              userid_split = userid
            }

            var row = {
              'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
              ...(['nestle'].includes(vm.selectedBot.type) ? { pageuid: userid_split } : {}),
              'Order Number': val.id,
              'Status Order': val.status,
              'Total per Order': val.allquantity ? `${val.allquantity}` : '-',
              SKU: typeof productdetail[0] == 'string' ? products.sku : productdetail[0].sku,
              Products:
                typeof productdetail[0] == 'string'
                  ? products.name
                  : `${productdetail[0].name}${
                      productdetail[0].option ? ` ${productdetail[0].option}` : ''
                    }`,
              'SKU Amount':
                typeof productdetail[0] == 'string'
                  ? productdetail[0].quantity
                  : products[0].quantity,
              Price:
                typeof productdetail[0] == 'string'
                  ? ''
                  : numeral(productdetail[0].price).format('0,0.00'),
              'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
              Discount: numeral(val.discount).format('0,0.00').toString(),
              Total: numeral(val.amount).format('0,0.00').toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Shippop Tracking No.': vm.selectedBot.shippop_status
                ? val.shippop_tracking_code
                : '-',
              Remark: val.remark != null ? val.remark : '',
              Channel: val.app,
              'Social Name': val.first_name + ' ' + val.last_name,
              Address: fullAddress,
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              'Customer Tags':
                vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              'Cutomer Code': couponcode
            }
            if (vm.selectedBot.theme == 'runkan') {
              Object.assign(row, {
                'Run status': val.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ'
              })
            }

            if (vm.selectedBot.theme === 'cityfresh') {
              Object.assign(row, {
                'Shipping Date': val.shipping_date
                  ? moment(val.shipping_date).format('DD/MM/YYYY')
                  : '-',
                'Shipping Time': val.shipping_time
              })
            }

            if (['dtac-gaming'].includes(vm.selectedBot.type)) {
              Object.assign(row, {
                'User ID': val.userid
              })
            }

            if (
              [
                '148831989096546',
                '1229692217050821',
                '135565533158593',
                '488563718210335',
                '799590883441878'
              ].includes(vm.selectedBot.pageid)
            ) {
              var remarksplit = []
              try {
                remarksplit = val.remark.split(';;')
                row.Remark = remarksplit[0]
                row['Bank Name'] = remarksplit.length > 1 ? remarksplit[1] : ''
              } catch (error) {
                row.Remark = val.remark
              }
            }

            if (
              ['176922345693076', '809510349133469', '103876431747147'].includes(
                vm.selectedBot.pageid
              )
            ) {
              var order = productdetail.find((el) => {
                return el.cart_remark != '' || el.cart_remark != null
              })
              if (order) {
                row['ขายโดย'] = order.cart_remark
              }
            }

            json.push({
              ...row,
              ...(['nestle'].includes(vm.selectedBot.type) ? { 'Order Tags': val.order_tags } : {})
            })

            if (productdetail.length > 1) {
              productdetail.map((detail, dindex) => {
                if (dindex != 0) {
                  json.push({
                    ...(['nestle'].includes(vm.selectedBot.type)
                      ? {
                          'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                          'Status Order': val.status,
                          pageuid: userid_split
                        }
                      : {}),
                    SKU: detail.sku,
                    Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                    Price: numeral(detail.price).format('0,0.00'),
                    'SKU Amount': detail.quantity,
                    ...(['nestle'].includes(vm.selectedBot.type)
                      ? {
                          'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                          Discount: numeral(val.discount).format('0,0.00').toString(),
                          Shipping: shippingType ? vm.$t(shippingType) : '',
                          'Tracking No.': val.trackingno,
                          'Shippop Tracking No.': vm.selectedBot.shippop_status
                            ? val.shippop_tracking_code
                            : '-',
                          Remark: val.remark != null ? val.remark : '',
                          Channel: val.app,
                          'Social Name': val.first_name + ' ' + val.last_name,
                          'Real Name': realname.length > 1 ? realname[0] : '',
                          Address: fullAddress,
                          Status:
                            vm.$store.getters.getPackage == 'premium' && val.userstatus
                              ? val.userstatus
                              : '-',
                          'Customer Tags':
                            vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
                          'Cutomer Code': couponcode
                        }
                      : {})
                  })
                }
              })
            }
          })
          filename = 'zwizshop'
        }
      }
      var dataWS = null
      if (type == 'kerry') dataWS = XLSX.utils.json_to_sheet(json, { origin: 'A8' })
      else dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    sapFormat(data) {
      var companyCode = '100'
      var systemCode = '10'
      var batchNo = moment().format('YYYYMMDD') + '001'
      var lotNo = companyCode + systemCode + batchNo

      var orders = []

      var prefix_filename = ''

      switch (this.selectedBot.pageid) {
        case '488563718210335': // moniga
          prefix_filename = 'MG_'
          break
        case '135565533158593': // monobo
          prefix_filename = 'MB_'
          break
        case '1229692217050821': // Kardas
          prefix_filename = 'KD_'
          break
        case '148831989096546': // Rubber Soul
          prefix_filename = 'RBS_'
          break

        default:
          break
      }

      // U_CompanyCode	U_SystemCode	U_TransBatchNo	U_LotNo	DocNum	NumAtCard	U_Status	DocDate	DocDueDate	DocTime	Comments	U_Channel	CardCode	CardName	U_SocialName	Address	U_Shipping	U_TrackingNo	DocCur	DocRate	DiscPrcnt	DocTotal	PaidSum	U_TrnsfDate

      // invoice header
      var invoiceHeader = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''
        var shippingType = ''
        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        var remark = ''
        try {
          remark = el.remark ? el.remark.replace(/[|]/g, '').replace(/\n/g, '') : ''
          remark = remark && remark.split(';;').length > 0 ? remark.split(';;')[0] : ''
        } catch (error) {
          remark = el.remark ? el.remark.replace(/\n/g, '').replace(/|/g, '') : ''
        }

        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          el.id,
          el.status,
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('HHmm'),
          remark,
          el.app,
          tel,
          realname.length > 1 ? realname[0] : '',
          el.first_name + ' ' + el.last_name,
          el.nameaddress.replace(/\n/g, ' ').replace(/[|]/g, ''),
          shippingType ? this.$t(shippingType) : '',
          el.trackingno,
          'THB',
          1,
          el.discount,
          numeral(el.amount).format('0.00').toString(),
          numeral(el.amount).format('0.00').toString(),
          ''
        ].join('|')
      })

      var invoiceDetails = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''
        var shippingType = ''

        var productdetail = []
        try {
          var products = JSON.parse(el.productdetail)
        } catch (error) {
          var products = el.productdetail
        }
        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function (product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            detail.sku,
            detail.name + detail.option,
            detail.quantity,
            numeral(detail.price / detail.quantity)
              .format('0.00')
              .toString(),
            numeral(detail.price).format('0.00').toString(),
            '',
            '',
            '',
            '',
            '',
            ''
          ].join('|')
        })

        return result.join('\n')
      })

      var paymentHeader = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''
        var shippingType = ''
        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var bankname = ''
        try {
          bankname = el.remark && el.remark.split(';;').length > 1 ? el.remark.split(';;')[1] : ''
        } catch (error) {
          bankname = ''
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('HHmm'),
          tel,
          realname.length > 1 ? realname[0] : '',
          'THB',
          1,
          '',
          numeral(el.amount).format('0.00').toString(),
          '',
          '',
          '',
          '',
          bankname,
          '',
          '',
          ''
        ].join('|')
      })

      var paymentDetails = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''
        var shippingType = ''

        var productdetail = []
        try {
          var products = JSON.parse(el.productdetail)
        } catch (error) {
          var products = el.productdetail
        }

        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function (product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            el.id,
            numeral(detail.price).format('0.00').toString()
          ].join('|')
        })

        return result.join('\n')
      })
      var invoiceHeader_Header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'NumAtCard',
        'U_Status',
        'DocDate',
        'DocDueDate',
        'DocTime',
        'Comments',
        'U_Channel',
        'CardCode',
        'CardName',
        'U_SocialName',
        'Address',
        'U_Shipping',
        'U_TrackingNo',
        'DocCur',
        'DocRate',
        'DiscPrcnt',
        'DocTotal',
        'PaidSum',
        'U_TrnsfDate'
      ]
      invoiceHeader_Header = invoiceHeader_Header.join('|')
      invoiceHeader.unshift(invoiceHeader_Header)
      this.exportText(
        invoiceHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_OINV_H`
      )

      var invoiceDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'LineNum',
        'ItemCode',
        'Dscription',
        'Quantity',
        'PriceAfVAT',
        'LineTotal',
        'WhsCode',
        'UseBaseUn',
        'OcrCode',
        'OcrCode3',
        'OcrCode4',
        'OcrCode5'
      ]
      invoiceDetails_header = invoiceDetails_header.join('|')
      invoiceDetails.unshift(invoiceDetails_header)
      this.exportText(
        invoiceDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_INV1_L`
      )

      var paymentHeader_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'DocDate',
        'DocTime',
        'CardCode',
        'CardName',
        'DocCurrency',
        'DocRate',
        'CashSum',
        'TransferSum',
        'CreditSum',
        'CheckSum',
        'CashAccount',
        'CheckAccount',
        'TransferAccount',
        'BankCode',
        'BankAccount',
        'Remarks'
      ]
      paymentHeader_header = paymentHeader_header.join('|')
      paymentHeader.unshift(paymentHeader_header)
      this.exportText(
        paymentHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_ORCT_H`
      )

      var paymentDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'ParentKey',
        'LineNum',
        'DocEntry',
        'PaidSum'
      ]
      paymentDetails_header = paymentDetails_header.join('|')
      paymentDetails.unshift(paymentDetails_header)
      this.exportText(
        paymentDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_RCT2_L`
      )
    },
    exportTrackingOrder() {
      let result = []
      if (['ordered', 'paid'].includes(this.filterStatus)) {
        result =
          this.filterStatus == 'ordered'
            ? this.filterOrders.filter((f) => f.status == 'ordered')
            : this.filterOrders.filter((f) => f.status == 'paid')
      } else {
        // Export only reviewing and paid
        result = this.filterOrders.filter((f) => f.status == 'paid' || f.status == 'ordered')
      }

      if (result.length == 0) {
        this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
      }

      result = result.map((d) => {
        return { orderNumber: d.id, trackingNo: d.trackingno, note: '' }
      })

      let hasTrackingResult = result.filter((f) => f.trackingNo != '' || f.trackingNo != null)
      if (hasTrackingResult.length > 0) {
        hasTrackingResult.forEach((d) => {
          let remarkIndex = d.trackingNo.indexOf('หมายเหตุ')
          let trackingno = ''
          let remark = ''
          if (remarkIndex != -1) {
            trackingno = d.trackingNo.substring(0, remarkIndex)
            remark = d.trackingNo.substring(remarkIndex)
            remark = remark.substring(10)
          }
          result.find((f) => f.orderNumber == d.orderNumber).trackingNo = trackingno
          result.find((f) => f.orderNumber == d.orderNumber).note = remark
        })
      }

      let dataWs = XLSX.utils.json_to_sheet(result)
      dataWs.A1.v = 'Order Number'
      dataWs.B1.v = 'Tracking No.'
      dataWs.C1.v = 'Note'
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWs)
      let exportDay = moment().format('DD/MM/YYYY')
      XLSX.writeFile(wb, 'Export Order No. ' + exportDay.toString() + '.xlsx')
    },
    async importTrackingOrder(payload) {
      this.$store.dispatch('loading')
      api.saveOrdersTracking(payload, (err, result) => {
        if (err) {
          this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
        } else {
          if (result.responsecode == 200) {
            this.IsImportTrackingSuccess = true
            setTimeout(() => {
              this.IsImportTrackingSuccess = false
              this.onRefresh()
            }, 2000)
          } else {
            this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
          }
        }
        this.$store.dispatch('loading')
      })
    },
    async handleImportFile(event) {
      if (event.target.files[0] === undefined) {
        return
      }

      //check file size
      const file_size = 26214400
      if (event.target.files[0].size > file_size) {
        this.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์ถูกจำกัดเพียง 25 MB เท่านั้น', 'warning')
        return
      }
      //check file type
      const file_type = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      if (!file_type.includes(event.target.files[0].type)) {
        this.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์รองรับไฟล์นามสกุล XLSX เท่านั้น', 'warning')
        return
      }
      const file = event.target.files[0]
      let data = await this.ExcelToJson(file)
      if (data) {
        data = data.map((d) => {
          return {
            id: Number(Object.values(d)[0]),
            trackNo: Object.values(d)[1].toString(),
            note: Object.values(d)[2]
          }
        })
        let payload = {
          pageid: this.selectedBot.pageid,
          orders: data
        }
        await this.importTrackingOrder(payload)
      } else {
        this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
      }
    },
    async ExcelToJson(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = (e) => {
          var data = e.target.result
          var workbook = XLSX.read(data, {
            type: 'binary'
          })
          workbook.SheetNames.forEach((sheetName) => {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
            var json_object = JSON.stringify(XL_row_object)
            resolve(JSON.parse(json_object))
          })
        }

        reader.onerror = function (ex) {
          console.log(ex)
        }
        reader.readAsBinaryString(file)
      })
    },
    handleChangeShop() {
      this.onRefresh()
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
        this.clearSelectAll()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-order-summary.vue